import { ApiObjectService } from './api-object.service'

class SparePartsService extends ApiObjectService {
    namespace = 'spare-parts'
}

export const sparePartsService = new SparePartsService()
